import { useTranslations, useLocale } from 'next-intl';
import { IoShieldOutline } from 'react-icons/io5';
import BranchesDropdown from '@/components/ourBranches/branches-dropdown';
import BranchCard from '../cards/branch-card';
import ShippingInfoBranchCardSkeleton from '../skeletons/Shipping-Info-Branch-Card-Skeleton';
import { useProductStoreLocator } from '@/hooks/product/useProductStoreLocator';
import { signIn, useSession } from 'next-auth/react';
import { usePathname } from 'next/navigation';

const StoreLocatorModal = ({ entity_id }) => {
  const t = useTranslations('branches');
  const { data: session } = useSession();
  const pathname = usePathname();
  const locale = useLocale();

  const { selectedBranches, setSelectedBranches, allBranches, isLoading } =
    useProductStoreLocator(entity_id, locale);

  return (
    <div className='relative p-2 lg:p-4'>
      {isLoading ? (
        <>
          {Array.from({ length: 2 }).map((_, i) => (
            <ShippingInfoBranchCardSkeleton fromPDP key={i} />
          ))}
        </>
      ) : allBranches?.length > 0 ? (
        <>
          <BranchesDropdown
            {...{
              t,
              selectedBranches,
              setSelectedBranches,
              locale,
              allBranches,
              isFromPDP: true,
            }}
          />
          <span className='mb-2 flex items-center gap-1 text-gray-600'>
            <IoShieldOutline />
            {t('available_in_pharmacy')}
          </span>

          {selectedBranches?.length > 0 ? (
            <div className='max-h-[50vh] overflow-y-auto'>
              {selectedBranches?.map((branch) => (
                <BranchCard
                  key={branch?.id}
                  selectedBranches={branch}
                  t={t}
                  fromPDP
                />
              ))}
            </div>
          ) : (
            <p className='py-4 text-center text-gray-600 max-sm:text-sm'>
              {t('no_results')}
            </p>
          )}
        </>
      ) : (
        <p className='text-center font-bold max-sm:text-sm'>
          {session?.user ?
            t('empty_store_locator')
            : <div className='flex items-center flex-col  gap-5 justify-center'>
              {t('empty_store_locator_guest')}
              <button onClick={() => signIn(null, { callbackUrl: pathname })} className='bg-primary text-white rounded-md px-3 py-2 '>
                {t('login')}
              </button>
            </div>}
        </p>
      )}
    </div>
  );
};

export default StoreLocatorModal;
